export class LensLayers {
    http;
    constructor(http) {
        this.http = http;
    }
    getLensLayers() {
        return this.http.get(`/api/lens_layers`).json();
    }
}
